import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

const AccountName = ({ name }) => {
    return (
        <div className={ styles.accountName }>
            <div className={ styles.label }>Your subscription: </div>
            <div className={ styles.text }>{ name }</div>
        </div>
    );
};

AccountName.propTypes = {
    name: PropTypes.string.isRequired
};

export default AccountName;
